import { __exportAll } from "../../_virtual/_rolldown/runtime.mjs";
import { BEGIN_LOADING_SESSION_INFO, BEGIN_LOG_IN, BEGIN_REGISTER, BEGIN_REQUEST_HUMAN_STATUS, BEGIN_REQUEST_RESET_PASSWORD, ERROR_LOG_IN, ERROR_REGISTER, ERROR_REQUEST_HUMAN_STATUS, ERROR_REQUEST_RESET_PASSWORD, ERROR_SESSION_INFO, FETCH_SESSION_INFO, LOGGED_OUT, LOG_IN, MAYBE_FETCH_SESSION_INFO, MAYBE_LOG_OUT, RECEIVE_SESSION_INFO, REGISTER, REQUEST_HUMAN_STATUS, REQUEST_RESET_PASSWORD, SUCCESS_LOG_IN, SUCCESS_REGISTER, SUCCESS_REQUEST_HUMAN_STATUS, SUCCESS_REQUEST_RESET_PASSWORD, TRACK_EVENT } from "./actionTypes.mjs";
//#region src/store/session/actions.ts
var actions_exports = /* @__PURE__ */ __exportAll({
	beginLoadingSessionInfo: () => beginLoadingSessionInfo,
	beginLogIn: () => beginLogIn,
	beginRegister: () => beginRegister,
	beginRequestHumanStatus: () => beginRequestHumanStatus,
	beginRequestPasswordReset: () => beginRequestPasswordReset,
	errorLogIn: () => errorLogIn,
	errorRegister: () => errorRegister,
	errorRequestHumanStatus: () => errorRequestHumanStatus,
	errorRequestPasswordReset: () => errorRequestPasswordReset,
	errorSessionInfo: () => errorSessionInfo,
	fetchSessionInfo: () => fetchSessionInfo,
	logIn: () => logIn,
	loggedOut: () => loggedOut,
	maybeFetchSessionInfo: () => maybeFetchSessionInfo,
	maybeLogOut: () => maybeLogOut,
	receiveSessionInfo: () => receiveSessionInfo,
	register: () => register,
	requestHumanStatus: () => requestHumanStatus,
	requestPasswordReset: () => requestPasswordReset,
	successLogIn: () => successLogIn,
	successRegister: () => successRegister,
	successRequestHumanStatus: () => successRequestHumanStatus,
	successRequestPasswordReset: () => successRequestPasswordReset,
	trackEvent: () => trackEvent
});
function maybeFetchSessionInfo() {
	return {
		payload: {},
		type: MAYBE_FETCH_SESSION_INFO
	};
}
function fetchSessionInfo() {
	return {
		payload: {},
		type: FETCH_SESSION_INFO
	};
}
function beginLoadingSessionInfo() {
	return {
		payload: {},
		type: BEGIN_LOADING_SESSION_INFO
	};
}
function receiveSessionInfo(info) {
	return {
		payload: { info },
		type: RECEIVE_SESSION_INFO
	};
}
function errorSessionInfo(error) {
	return {
		payload: { error },
		type: ERROR_SESSION_INFO
	};
}
function beginLogIn() {
	return {
		payload: {},
		type: BEGIN_LOG_IN
	};
}
function errorLogIn(error, statusCode) {
	return {
		payload: {
			error,
			statusCode
		},
		type: ERROR_LOG_IN
	};
}
function logIn(email, password, googleIDToken, facebookIDToken) {
	return {
		payload: {
			email,
			password,
			googleIDToken,
			facebookIDToken
		},
		type: LOG_IN
	};
}
function successLogIn(serverLoginRedirect) {
	return {
		payload: serverLoginRedirect ? { serverLoginRedirect } : {},
		type: SUCCESS_LOG_IN
	};
}
function beginRequestHumanStatus() {
	return {
		payload: {},
		type: BEGIN_REQUEST_HUMAN_STATUS
	};
}
function errorRequestHumanStatus(error, statusCode) {
	return {
		payload: {
			error,
			statusCode
		},
		type: ERROR_REQUEST_HUMAN_STATUS
	};
}
function requestHumanStatus(email) {
	return {
		payload: { email },
		type: REQUEST_HUMAN_STATUS
	};
}
function successRequestHumanStatus(email, hasGeneratedPassword, isNewHuman = false) {
	return {
		payload: {
			email,
			hasGeneratedPassword,
			isNewHuman
		},
		type: SUCCESS_REQUEST_HUMAN_STATUS
	};
}
function beginRequestPasswordReset() {
	return {
		payload: {},
		type: BEGIN_REQUEST_RESET_PASSWORD
	};
}
function errorRequestPasswordReset(error, statusCode) {
	return {
		payload: {
			error,
			statusCode
		},
		type: ERROR_REQUEST_RESET_PASSWORD
	};
}
function requestPasswordReset(email) {
	return {
		payload: { email },
		type: REQUEST_RESET_PASSWORD
	};
}
function successRequestPasswordReset(email, hasGeneratedPassword, isNewHuman = false) {
	return {
		payload: {
			email,
			hasGeneratedPassword,
			isNewHuman
		},
		type: SUCCESS_REQUEST_RESET_PASSWORD
	};
}
function beginRegister() {
	return {
		payload: {},
		type: BEGIN_REGISTER
	};
}
function errorRegister(error) {
	return {
		payload: { error },
		type: ERROR_REGISTER
	};
}
function register(email, name, password, phone, googleIDToken, facebookIDToken, passwordlessToken, hasGeneratedPassword, redirectUrl) {
	return {
		payload: {
			email,
			name,
			password,
			phone,
			googleIDToken,
			facebookIDToken,
			passwordlessToken,
			hasGeneratedPassword,
			redirectUrl
		},
		type: REGISTER
	};
}
function successRegister(serverLoginRedirect) {
	return {
		payload: serverLoginRedirect ? { serverLoginRedirect } : {},
		type: SUCCESS_REGISTER
	};
}
function maybeLogOut() {
	return {
		payload: {},
		type: MAYBE_LOG_OUT
	};
}
function loggedOut() {
	return {
		payload: {},
		type: LOGGED_OUT
	};
}
var trackEvent = (category, action, label, extra) => {
	return {
		payload: {
			category,
			action,
			label,
			extra
		},
		type: TRACK_EVENT
	};
};
//#endregion
export { actions_exports, beginLoadingSessionInfo, beginLogIn, beginRegister, beginRequestHumanStatus, beginRequestPasswordReset, errorLogIn, errorRegister, errorRequestHumanStatus, errorRequestPasswordReset, errorSessionInfo, fetchSessionInfo, logIn, loggedOut, maybeFetchSessionInfo, maybeLogOut, receiveSessionInfo, register, requestHumanStatus, requestPasswordReset, successLogIn, successRegister, successRequestHumanStatus, successRequestPasswordReset, trackEvent };

//# sourceMappingURL=actions.mjs.map